import { Corner2DEditorDockingPanelContent } from "./content/corner2DEditorDockingPanelContent";
import { DockingPanel } from "./dockingPanel";

export class Corner2DEditorDockingPanel {
    private readonly panel: DockingPanel;
    private _visible: boolean;

    constructor(container: HTMLElement, isMetric: boolean) {
        this._visible = false;

        const component = <Corner2DEditorDockingPanelContent isMetric={isMetric} />;

        const containerRect = container.getBoundingClientRect();

        this.panel = new DockingPanel(container, "dextall-corner-panel-2d-editor", "Corner type", component, {
            style: {
                resize: "both",
            },
            dimensionsControl: {
                preventOverlapsWithViewerToolbar: true,
                widthDimensionControl: { value: 0.33 * containerRect.width, minValue: 560 },
                heightDimensionControl: { value: 0.7 * containerRect.height, minValue: 560 },
                topOffset: 2,
                rightOffset: 2,
            },
            carefullBringToFront: true,
        });

        this.panel.addToggleFullSizeButton();

        this.panel.addVisibilityListener((x: boolean) => this._visible = x);
    }

    get visible() {
        return this._visible;
    }

    setVisible(visibility: boolean) {
        if (this._visible === visibility) {
            return;
        }

        this._visible = visibility;
        this.panel.setVisible(visibility);
    }

    shutdown() {
        this.panel.shutdown();
    }
}
